import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import UserLayout from "./layout/UserLayout";
import Home from "./Pages/Home";
import Project from "./Pages/Project";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import WhatsAppFloat from "./component/WhatsAppFloat";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
           <WhatsAppFloat />
      <Routes>
        <Route path="/" element={<UserLayout />}>
          <Route index element={<Home />} />
          <Route path="project"  element={<Project/>} />
          <Route path="About"  element={<About/>} />
          <Route path="Contact"  element={<Contact/>} />
 
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;